import { render } from "./App.vue?vue&type=template&id=46401b2c"
const script = {}

import exportComponent from "D:\\Personal\\Projects\\project-ralph\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__